import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

export type ConversationsFilter = 'all' | 'unread';

@Component({
  selector: 'be-conversations-filters',
  templateUrl: './conversations-filters.component.html',
  styleUrls: ['./conversations-filters.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConversationsFiltersComponent {
  readonly activeFilter = input<ConversationsFilter>('all');
  readonly activeFilterChange = output<ConversationsFilter>();

  protected readonly filters: readonly { value: ConversationsFilter; label: string }[] = [
    { value: 'all', label: 'All' },
    { value: 'unread', label: 'Unread' },
  ];

  protected selectFilter(filter: ConversationsFilter): void {
    if (filter !== this.activeFilter()) {
      this.activeFilterChange.emit(filter);
    }
  }
}
